namespace Nobox.Nobox {
    export interface RequesAddContact {
        ListContact?: string;
        ListId?: string;
    }
}
